import { RootState } from 'editor/src/store/index';

const getAddonsSearch = (state: RootState) => state.editorModules.addons.data?.search.value || '';

export default getAddonsSearch;
